import * as React from 'react';
import {Typography, WithStyles, withStyles, } from '@material-ui/core';
import { IEcoTransfer, IEcoSplitSetting} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import { ecoContainerStyle } from './Container.style';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import {EditOutlined} from "@material-ui/icons";
import { FamilyMemberType } from '@services/family/family.constants';
import { getPercentage, getTransferBalance, isDeletedByNonCreator } from '@helpers/EconomyHelper';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as ChatActions from '@services/chat/chat.actions';
import { connect } from 'react-redux';
import { ICreateChat, ChatType } from '@app-types/websocket/chat.types';
import ChatIcon from '@material-ui/icons/QuestionAnswerOutlined';
import ChatButton from './ChatButton';
import { styleColors } from 'src/main.style';

const tn = TranslateNew.getInstance();

interface IProps extends RouteComponentProps,  WithStyles<typeof ecoContainerStyle>
{
    transfer: IEcoTransfer;
    family: IFamilyMember[];
    userId:number;
    currency:string;
    settings:IEcoSplitSetting[];
    editTransfer: (purchase:IEcoTransfer) => void;
    seenTransfer: (id:number) => void;
    createChat: (data: ICreateChat) => void;
    scrollTime:number;
    waitForTransferChat:(id:number) => void;
}

interface IState
{
    explain: boolean;
    seenCalled: boolean;
}

class ListItemTransfer extends React.Component<IProps,IState> {

    private myRef: HTMLDivElement | null = null;

    constructor(props: IProps) {
        super(props);
    
        this.state = {
            explain: false,
            seenCalled: false,
        };
    
    }

    public componentDidMount() {
        if (this.state.seenCalled === false 
          && this.props.transfer.seenBy.indexOf(this.props.userId) === -1) {
          if (this.isInViewport()) {
            this.setState({seenCalled:true});
            this.props.seenTransfer(this.props.transfer.id);
          }
        }
    }

    public componentDidUpdate(prevProps: Readonly<IProps>): void {
        if (this.state.seenCalled === false 
            && prevProps.scrollTime !== this.props.scrollTime
            && this.props.transfer.seenBy.indexOf(this.props.userId) === -1) 
        {
            if (this.isInViewport()) {
              this.setState({seenCalled:true});
              this.props.seenTransfer(this.props.transfer.id);
            }
          }
    }

    public render() { 
        const {userId, classes, transfer, family, currency} = this.props;
        const doneBy = this.props.family.find((mem) => mem.id === transfer.from);
        const doneTo = this.props.family.find((mem) => mem.id === transfer.to);

        const balance = getTransferBalance(transfer, userId, this.props.settings);
        const balanceColor = balance > 0
            ? styleColors.callGreen
            : balance < 0 ? styleColors.coralRed : styleColors.greyDark2;
        const declinedToShare = isDeletedByNonCreator(transfer);
        const chatId = transfer.chatId;

        let chatButton:JSX.Element|undefined;
        if (transfer.disputedBy !== undefined) {
            chatButton = <ChatButton referenceObject={transfer.id} family={family} chatId={transfer.chatId} chatType={ChatType.TRANSFER_CHAT}
                title = {tn.lang.transferRegardingTitle(tn.formatNumber(transfer.sum, currency), tn.formatMonthDate(new Date(transfer.date)))} 
                msg = {transfer.note?transfer.note:""} waitForTransferChat={this.props.waitForTransferChat}/>;
        } 

        return(
            <div className={classes.cardContent} id={"tra"+transfer.id}
                ref={(el) => this.myRef = el}
                style={(!transfer.seenBy.includes(userId) && !transfer.deleted)
                    ?{ boxShadow: `0px 0px 20px ${styleColors.redShadow23}`, backgroundColor: styleColors.brightCoralTint12, }
                    :{ boxShadow: '0px 0px 20px rgb(255 0 0 / 0%)', backgroundColor: styleColors.transparent,
                        opacity: transfer.deleted ? 0.5 : 1, }}>
                <div className={classes.cardContentListItem} style={{maxWidth:chatButton===undefined?'100%':'calc(100% - 36px)',
                    minWidth:chatButton===undefined?'100%':'calc(100% - 36px)'}}>
                    <div className={classes.itemTopRow}>
                        <div className={classes.body2} onClick={() => this.props.editTransfer(transfer)} style={{cursor:'pointer'}}>
                            {tn.formatDateShort(new Date(transfer.date)) }
                        </div>                                  
                    </div>
                    <div className={classes.itemTopRow}>
                        {doneBy && <ImgAvatar color={doneBy.color} imgName={doneBy.avatar}  imgUrl={doneBy.imageAvatar?doneBy.avatarURL:undefined}
                            style={{width:14, height:14}} altText={doneBy.firstName} />}
                        <div className={classes.parentWithTraillingText} onClick={() => this.props.editTransfer(transfer)}>
                            <Typography className={[ classes.body1, classes.traillingTittle].join(' ')}
                                style={{cursor:'pointer', textDecoration: transfer.deleted ? 'line-through' : 'none'}}>
                                {tn.lang.ecoTransferTitle(doneTo, doneBy)}
                            </Typography>
                        </div>
                        <Typography className={classes.body1} component="div" onClick={() => this.explain(transfer.id)}
                            style={{cursor:'pointer', color: balanceColor, textDecoration: transfer.deleted ? 'line-through' : 'none'}}>
                            {tn.formatNumber(balance, this.props.currency)}
                        </Typography>                                  
                    </div>
                    <div className={classes.itemBottomRow}>
                        <Typography component="div" color="textSecondary" className={classes.body2}
                            style={{marginRight:20, cursor:'pointer', color: declinedToShare ? styleColors.coralRed : undefined}}
                            onClick={() => this.props.editTransfer(transfer)}>
                            {transfer.deleted
                                ? (declinedToShare ? tn.lang.ecoDeclinedToShare : tn.lang.ecoDeletedByCreator)
                                : this.renderTransferExplanation(transfer, this.state.explain)}
                        </Typography>
                        {!transfer.deleted &&
                            <Typography onClick={() => this.explain(transfer.id)}
                                component="div" style={{cursor:'pointer'}} color="textSecondary" className={classes.body2}>
                                {this.state.explain?("     "+tn.lang.OK):tn.lang.explain}
                            </Typography>}
                    </div>
                </div>
                {chatButton}
            </div>
        );
    }

    private isInViewport(offset = 0) {
        if (!this.myRef) { return false; }
        const rect = this.myRef.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
    
        if (!(rect.left >= 0 && rect.right <= viewWidth)) { return false; }
        if (!(rect.top >= 0 && (rect.top + 50) <= viewHeight)) { return false; } // if 50 pixels has been seen thats enough
    
        return true;
    }

    private renderTransferExplanation(transfer:IEcoTransfer, shouldExplain:boolean) {
        if (shouldExplain) {
            if (transfer.to > 0 && transfer.from > 0 && transfer.to !== transfer.from) {
                return tn.lang.ecoExplainTransfer(transfer.to, transfer.from, this.props.family, transfer.sum, this.props.currency);
            } else if (transfer.to === 0 && transfer.from === 0) {
                return tn.lang.ecoExplainTransferSharedToShared;
            } else if (transfer.to === 0) {
                const otherParent = this.props.family.find((mem) => (mem.role === FamilyMemberType.PARENT && mem.id !== transfer.from));
                const otherParentId = otherParent?otherParent.id:-1;
                const percentage = getPercentage(transfer.from, transfer.date, this.props.settings);
                return tn.lang.ecoExplainTransferToShared(otherParentId, transfer.from, percentage, this.props.family, 
                    transfer.sum, this.props.currency);
            } else if (transfer.from === 0) {
                const otherParent = this.props.family.find((mem) => (mem.role === FamilyMemberType.PARENT && mem.id !== transfer.to));
                const otherParentId = otherParent?otherParent.id:-1;
                const percentage = getPercentage(transfer.to, transfer.date, this.props.settings);
                return tn.lang.ecoExplainTransferFromShared(transfer.to, percentage, otherParentId, this.props.family, 
                    transfer.sum, this.props.currency);
            } else return tn.lang.unknown;
        } else {
            return (<>
                    {`${transfer.sum} ${this.props.currency} via ${tn.lang.transferOption(transfer.method)}.`}
                    {(!!transfer.note && transfer.note.length > 0) 
                        && transfer.note}
                    {(transfer.chatId !== undefined) 
                        && <ChatIcon style={{fill:styleColors.warmGrey, fontSize:'12px'}}  />}
            </>);
        }
    }

    private explain(purchaseId:number) {
        this.setState({explain:!this.state.explain});
    }
}

const mapDispatchToProps = {
    createChat: ChatActions.createChat,
};
export default withRouter(connect(null, mapDispatchToProps)(withStyles(ecoContainerStyle)(ListItemTransfer)));



// WEBPACK FOOTER //
// ./src/components/economy/ListItemTransfer.tsx